import pick from 'lodash/pick';
import pickBy from 'lodash/pickBy';
import startCase from 'lodash/startCase';

export const lodashFunctions = {
  pick,
  pickBy,
  startCase,
};
